import React from 'react';
import { Link } from 'react-router-dom';
import { FaHandHoldingHeart, FaUsers, FaCalendarAlt, FaPhoneAlt } from 'react-icons/fa';
import BloodDonation from './BloodDonation';
import DonorStories from './DonorStories';
import DonationCounter from './DonationCounter';

const Home = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <div className="relative h-[80vh] flex items-center justify-center">
        <div className="absolute inset-0 bg-gradient-to-r from-[#6dd5ed] to-[#eecda3] opacity-90"></div>
        <div className="relative z-10 text-center px-4">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Welcome to VALARCCI FOUNDATION
          </h1>
          <p className="text-xl md:text-2xl text-white mb-8 max-w-3xl mx-auto">
            Empowering communities through healthcare, education, and social welfare initiatives
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/blood-donation"
              className="bg-white text-blue-400 px-8 py-3 rounded-lg text-lg font-semibold hover:bg-blue-50 transition-colors duration-300"
            >
              Donate Blood
            </Link>
            <Link
              to="/donate"
              className="bg-blue-400 text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-blue-500 transition-colors duration-300"
            >
              Make a Donation
            </Link>
          </div>
        </div>
      </div>

      {/* Key Features Section */}
      <div className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-black">Our Key Initiatives</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Blood Donation */}
            <div className="bg-white rounded-lg p-6 shadow-xl text-center">
              <div className="text-4xl text-blue-400 mb-4 flex justify-center">
                <FaHandHoldingHeart />
              </div>
              <h3 className="text-xl font-bold mb-2">Blood Donation</h3>
              <p className="text-gray-600">
                Join our blood donation drives and help save lives in your community
              </p>
              <Link
                to="/blood-donation"
                className="inline-block mt-4 text-blue-400 hover:text-blue-500"
              >
                Learn More →
              </Link>
            </div>

            {/* Community Support */}
            <div className="bg-white rounded-lg p-6 shadow-xl text-center">
              <div className="text-4xl text-blue-400 mb-4 flex justify-center">
                <FaUsers />
              </div>
              <h3 className="text-xl font-bold mb-2">Community Support</h3>
              <p className="text-gray-600">
                Empowering communities through education and healthcare initiatives
              </p>
              <Link
                to="/about"
                className="inline-block mt-4 text-blue-400 hover:text-blue-500"
              >
                Learn More →
              </Link>
            </div>

            {/* Upcoming Events */}
            <div className="bg-white rounded-lg p-6 shadow-xl text-center">
              <div className="text-4xl text-blue-400 mb-4 flex justify-center">
                <FaCalendarAlt />
              </div>
              <h3 className="text-xl font-bold mb-2">Upcoming Events</h3>
              <p className="text-gray-600">
                Stay updated with our upcoming blood donation camps and community events
              </p>
              <Link
                to="/events"
                className="inline-block mt-4 text-blue-400 hover:text-blue-500"
              >
                Learn More →
              </Link>
            </div>

            {/* Contact Us */}
            <div className="bg-white rounded-lg p-6 shadow-xl text-center">
              <div className="text-4xl text-blue-400 mb-4 flex justify-center">
                <FaPhoneAlt />
              </div>
              <h3 className="text-xl font-bold mb-2">Contact Us</h3>
              <p className="text-gray-600">
                Get in touch with us for any queries or to participate in our initiatives
              </p>
              <Link
                to="/contact"
                className="inline-block mt-4 text-blue-400 hover:text-blue-500"
              >
                Learn More →
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Donation Counter Section */}
      <div className="bg-gradient-to-r from-[#eecda3] to-[#6dd5ed] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <DonationCounter />
        </div>
      </div>

      {/* Blood Donation Section */}
      <div className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-black">Blood Donation</h2>
          <BloodDonation />
        </div>
      </div>

      {/* Donor Stories Section */}
      <div className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-[#6dd5ed] to-[#eecda3]">
        <div className="max-w-7xl mx-auto">
          {/* <DonorStories /> */}
        </div>
      </div>

      {/* Call to Action Section */}
      <div className="bg-gradient-to-r from-[#6dd5ed] to-[#eecda3] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Make a Difference Today</h2>
          <p className="text-xl text-white mb-8">
            Your support can help us reach more communities and save more lives
          </p>
          <Link
            to="/donate"
            className="bg-white text-blue-400 px-8 py-3 rounded-lg text-lg font-semibold hover:bg-blue-50 transition-colors duration-300 inline-block"
          >
            Donate Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home; 